import React, { useEffect, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components';
import { confirmAlert } from "react-confirm-alert";
import { useAlert } from "react-alert";

export default function AddNews({ itsEditing, data }) {
    let alert = useAlert();
    const [files, setFiles] = useState([]);
    const [videolink, setvideolink] = useState("");

    const Container = styled.div`
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        border-width: 2px;
        border-radius: 2px;
        border-color: #0d6efd;
        border-style: dashed;
        background-color: #fafafa;
        color: #bdbdbd;
        outline: none;
        transition: border .24s ease-in-out;
    `;

    const thumbInner = {
        width: '200px',
        padding: '25px',
        border: "1px #011b6c solid",
        borderRadius: "5px",
        textAlign: "center"
    };

    const img = {
        width: '100px',
        height: '100px'
    };

    function StyledDropzone(props) {
        const {
            getRootProps,
            getInputProps,
            isFocused,
            isDragAccept,
            isDragReject
        } = useDropzone({
            accept: { 'image/*': [] }, onDrop: acceptedFiles => {
                setFiles(...files.push({
                    id: 0, file: acceptedFiles.map(file => Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    }))
                }));
            }
        });

        const deleteImage = (index, id) => {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className="AlertUI">
                            <h1>Aviso</h1>
                            <p>
                                ¿Deseas eliminar la imagen?
                            </p>
                            <button onClick={onClose}>No</button>
                            <button
                                onClick={() => {
                                    setFiles(files.filter((item, ind) => (ind !== index)));
                                    onClose()
                                }}
                            >
                                Si
                            </button>
                        </div>
                    );
                },
            });
        }

        const thumbs = files.map((file, index) => (
            <div key={index}>
                <div style={thumbInner} className="ImageBackground">
                    <div className="row text-center">
                        <div className="col-md-12">
                            <img
                                src={file.idnews ? file.preview : file.file[0].preview}
                                style={img}
                                alt='Upper File'
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button type='button' className='btn btn-danger mt-4 form-control' onClick={() => deleteImage(index, file.id)}>Eliminar</button>
                        </div>
                    </div>
                </div>
            </div>
        ));

        return (
            <div className="container">
                <Container {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
                    <input {...getInputProps()} />
                    <p>Arrastra o da clic para subir las imagenes (Una por una)</p>
                </Container>
                <aside className='CalendarContainer pt-4' style={{ justifyContent: "center" }}>
                    {thumbs}
                </aside>
            </div>
        );
    }

    const validation = Yup.object().shape({
        title: Yup.string().required(""),
        news: Yup.string().required(""),
    });

    const formOptions = { resolver: yupResolver(validation) };

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm(formOptions);

    async function onSubmit({ news, title }) {
        if (files.length == 0) {
            alert.show(
                "Agrega por lo menos una imagen",
                {
                    timeout: 3000,
                    type: "error",
                }
            );
            return
        }

        var idnew = (itsEditing ? data.info.idnews : 0);

        const formData = new FormData();
        formData.append("news", JSON.stringify({ videolink, news, title, idnew, editing: itsEditing }));

        files.map((f, i) => {
            if (typeof (f.file) != "undefined") {
                formData.append(`news-${i}`, f.file[0]);
            }
        });

        fetch(`${process.env.REACT_APP_URL_API}/data/saveNews`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: formData,
        }).then((response) => response.json())
            .then((datar) => {
                if (datar.rows > 0 || itsEditing) {
                    alert.show("Datos Guardados", {
                        timeout: 2000,
                        type: "success",
                        onClose: () => {
                            window.location.reload();
                        },
                    });
                } else {
                    alert.show(
                        "Ocurrió un error al guardar los datos, por favor intenta de nuevo",
                        {
                            timeout: 3000,
                            type: "error",
                        }
                    );
                }
            })
            .catch((error) => {
                alert.show(
                    "Ocurrió un error al guardar los datos, por favor intenta de nuevo " +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }

    useEffect(() => {
        if (itsEditing) {
            setValue("title", data.info.title)
            setValue("news", data.info.news)
            setvideolink(data.info.link)
            setFiles(data.images)
        }
    }, [])


    return (
        <div className='container'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-md-12">
                        <label htmlFor="">Título</label>
                        <input type="text" {...register("title")} name='title' tabIndex={1} className={`form-control ${errors.title ? "is-invalid" : ""}`} />
                        <div className="invalid-feedback">
                            {errors === {}
                                ? ""
                                : "El título es requerido"}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label htmlFor="">Noticia</label>
                        <textarea type="text" {...register("news")} name='news' tabIndex={2} cols={5} rows={15} className={`form-control ${errors.news ? "is-invalid" : ""}`} />
                        <div className="invalid-feedback">
                            {errors === {}
                                ? ""
                                : "La noticia es requerida"}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label htmlFor="">Link de Video</label>
                        <input type="text" tabIndex={3} value={videolink} onChange={(e) => { setvideolink(e.target.value) }} className='form-control' />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label htmlFor="">Imagenes de la noticia</label>
                        <StyledDropzone />
                    </div>
                </div>
                <br />
                <img src="../linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
                <div className="row">
                    <div className="col-md-2">
                        <button className="btn btn-success">Guardar</button>
                    </div>
                </div>
            </form>
        </div>
    )
}
